export default __webpack_public_path__ + "static/media/6.7eb717b9.jpg";